module.exports = __webpack_public_path__ + "img/chicken.410a968f.png";